var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items-per-page":15,"items":_vm.mappedMember,"disable-sort":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.more",fn:function(ref){
var item = ref.item;
return [_c('a',{on:{"click":function($event){return _vm.seeMore(item)}}},[_vm._v("view")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }